<template>
  <b-modal
    id="create-agent-subscription-modal"
    centered
    hide-footer
    title="Assign Subscription"
  >

    <b-form-group label="Agent">
      <b-form-select v-model="agent" :options="agentOptions"/>
    </b-form-group>

    <b-form-group label="Subscription Plan">
      <b-form-select v-model="plan" :options="planOptions"/>
    </b-form-group>

    <b-form-group label="Start Date">
      <b-form-input type="date" v-model="start_date"/>
    </b-form-group>

    <b-form-group label="End Date">
      <b-form-input type="date" v-model="end_date"/>
    </b-form-group>

    <b-form-checkbox v-model="is_active">
      Active Subscription
    </b-form-checkbox>

    <div class="text-right mt-3">
      <b-button variant="primary" @click="submit">
        Assign
      </b-button>
    </div>

  </b-modal>
</template>

<script>
import { mapActions } from "vuex";

export default {
  data() {
    return {
      agent: null,
      plan: null,
      start_date: "",
      end_date: "",
      is_active: true,
      agentOptions: [],
      planOptions: []
    };
  },

  mounted() {
    this.fetchAgents();
    this.fetchPlans();
  },

  methods: {
    ...mapActions("appData", [
      "getUsersDDL",
      "getSubscriptionPlans",
      "createAgentSubscription"
    ]),

    async fetchAgents() {
      const res = await this.getUsersDDL();
      const list = (res.data && Array.isArray(res.data)) ? res.data : (res.data && res.data.results) ? res.data.results : [];
      console.log("Agents:", list);
      this.agentOptions = [
        { value: null, text: "Select agent..." },
        ...list
          .filter(a => a.agent_profile)
          .map(a => ({
            value: a.id,
            text: a.agent_profile.full_name || "Unknown"
          }))
      ];
    },

    async fetchPlans() {
      const res = await this.getSubscriptionPlans({ page: 1 });
      const list = (res.data && res.data.results) ? res.data.results : (Array.isArray(res.data) ? res.data : []);
      this.planOptions = [
        { value: null, text: "Select plan..." },
        ...list.map(p => ({ value: p.id, text: p.name || "Unknown" }))
      ];
    },

    async submit() {
      await this.createAgentSubscription({
        agent: this.agent,
        plan: this.plan,
        start_date: this.start_date,
        end_date: this.end_date,
        is_active: this.is_active
      });

      this.$bvModal.hide("create-agent-subscription-modal");
      this.$emit("modalClosed");
    }
  }
};
</script>